import { type QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import * as qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import { getRequestParams } from '../helpers/getRequestParams';
import type { ICartRange, IFilter } from '../model/engagementFilter';
import type {
  IEngagementStatsActionList,
  IUseEngagementStatsActionListKeys,
} from '../model/engagementStatsActionList';

export const engagementStatsActionListKey = (
  keys: IUseEngagementStatsActionListKeys,
): [string, IFilter, ICartRange, Array<number>, ITableSorting, string] => [
  'engagementStatsActionList',
  keys.filter,
  keys.cartRange,
  keys.locationIds,
  keys.sorting,
  keys.search,
];

export const engagementStatsActionListFn = ({
  queryKey,
  pageParam = 1,
}: QueryFunctionContext<ReturnType<typeof engagementStatsActionListKey>, number>) => {
  const { filterParams, sortParams } = getRequestParams({
    filter: queryKey[1],
    cartRange: queryKey[2],
    locationIds: queryKey[3],
    sorting: queryKey[4],
  });

  const searchValue = queryKey[5];

  const pagination = {
    page: pageParam,
    pageSize: 30,
  };

  return apiClient
    .get(`${APP_API_URL_V2}fsd/action-item/report/engagement-stats/action-list`, {
      params: { pagination, filter: filterParams, search: searchValue, sort: [sortParams] },
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    })
    .then(({ data }: AxiosResponse<IEngagementStatsActionList>) => ({
      actionItems: data.data,
      ...data.meta,
    }));
};
export const useEngagementListInfiniteQuery = (keys: IUseEngagementStatsActionListKeys) => {
  return useInfiniteQuery({
    queryKey: engagementStatsActionListKey(keys),
    queryFn: engagementStatsActionListFn,
    getNextPageParam: ({ onLastPage, currentPage }) => (!onLastPage ? currentPage + 1 : undefined),
    enabled: keys.enabled,
    keepPreviousData: true,
  });
};
